import { render, staticRenderFns } from "./WorkflowBookmark.vue?vue&type=template&id=3ea0ae49&"
import script from "./WorkflowBookmark.vue?vue&type=script&lang=js&"
export * from "./WorkflowBookmark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports